
import TitleBox from '@/components/CSS/TitleBox'
import SyncPrice from '@/components/SyncPrice/index.vue'
// import { throttle } from '@/utils/index.js'
import { mapGetters } from 'vuex'
export default {
	components: {
		TitleBox
	},
	computed: {
		...mapGetters({
			userinfo: 'user/userinfo'
		})
	},
	data() {
		return {
			titleBoxTitle: '咨询回复',
			goodsInfo: null, // 商品信息
			listData: [], // 列表信息
			submitList: [], // 提交单选数据整合
			submitInputList: [], // 提交输入框数据整合
			loading: false,
			income: 0, //到手价
			serviceCharge: 0, //代售费
			originPrice: null, //页面最初获取到的最低价格
			priceInfo: null, //页面心里底价的信息
			priceInfoIndex: 0
		}
	},
	mounted() {
		this.getInfo()
	},
	methods: {
		onUpdatePrice(newValue) {
			if (this.priceInfo.labelType !== 'PRICE') {
				return
			}
			const params = {
				action: {
					gameId: this.priceInfo.gameId,
					goodsCatalogueId: this.priceInfo.gameCatalogueId,
					goodsPrice: Number(newValue),
					goodsNo: this.$route.query.goodsNo
				}
			}
			const priceReg = new RegExp(/(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/)
			if (!priceReg.test(Number(newValue))) {
				return
			}
			this.$api.getBargainFee(params).then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				this.serviceCharge = res.data.serviceFee
				this.income = parseFloat(Number(newValue) - res.data.serviceFee).toFixed(2)
				this.listData[this.priceInfoIndex].value = newValue
			})
		},
		// 返回
		back() {
			this.$router.go(-1)
		},
		// 获取初始化数据
		getInfo() {
			let _data = {
				goodsNo: this.$route.query.goodsNo
			}
			this.$api.getConsultLabelSellerInfo(_data).then(res => {
				if (!res.success) return this.$message.error(res.info)
				res.data.map((item, index) => {
					if (item.labelType === 'PRICE') {
						this.originPrice = item.value
						this.priceInfo = item
						this.priceInfoIndex = index
					}
				})
				this.listData = res.data
			})
			this.$api.goodsDetails({ action: { ..._data } }).then(res => {
				if (!res.success) return this.$message.error(res.info)
				this.goodsInfo = res.data
			})
		},
		// 提交-是否验证同步价格的判断
		submitJudge() {
			this.submitInputList = []
			let _listData = this.listData.filter(item => item.fieldType == 'TEXT' || item.fieldType == 'SECTION')
			_listData.map((item, index) => {
				if (this.submitInputList.filter(items => item.labelId == items.labelId).length == 0 && item.timeout && item.value) {
					this.submitInputList.push({
						labelId: item.id,
						value: item.value
					})
				}
			})
			let data = {
				goodsNo: this.$route.query.goodsNo,
				submitList: [...this.submitList, ...this.submitInputList]
			}
			if (!data.submitList.length) {
				this.$message.error('暂无更新')
				return
			}
			if (this.priceInfo && this.priceInfo.labelType === 'PRICE' && this.priceInfo.value && this.priceInfo.value !== this.originPrice) {
				if (this.priceInfo.value <= this.serviceCharge) {
					return this.$message.error(`低于最低可售卖价格${this.serviceCharge}元，请重新设置账号价格`)
				}
				const model = this.$pzDialog(
					{
						title: '更新提交',
						showFooter: false,
						showClose: true,
						width: '450px',
						component: SyncPrice,
						componentData: { price: this.priceInfo.value },
						onConfirm: ({ updatePrice }) => {
							this.submit({ updatePrice, ...data })
							model.remove()
						}
					},
					this
				)
			} else {
				this.submit(data)
			}
		},
		// 提交数据
		submit(data) {
			this.loading = true
			this.$api.getConsultLabelSellerSubmit(data).then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					this.loading = false
					this.submitList = []
					return
				}
				this.$message.success('保存成功')
				this.getInfo()
				this.submitList = []
				this.loading = false
			})
		},
		// 更新单选值
		getRadio(val) {
			if (this.submitList.filter(item => item.labelId == val.labelId).length == 0) {
				this.submitList.push(val)
			} else {
				this.submitList.map((item, index) => {
					if (item.labelId == val.labelId) {
						this.submitList[index] = val
					}
				})
			}
		},
		// 更新多选值
		getCheck(val) {
			if (this.submitList.filter(item => item.labelId == val.labelId).length == 0) {
				this.submitList.push(val)
			} else {
				this.submitList.map((item, index) => {
					if (item.labelId == val.labelId) {
						if (val.value == '[]') {
							this.submitList.splice(index, 1)
						} else {
							this.submitList[index] = val
						}
					}
				})
			}
		}
	}
}
// 节流
function throttle(func, wait) {
	let timeout = null
	let lastExecution = 0
	return function (...args) {
		const context = this
		const now = Date.now()
		if (lastExecution && now - lastExecution < wait) {
			clearTimeout(timeout)
			timeout = setTimeout(() => {
				lastExecution = now
				func.apply(context, args)
			}, wait - (now - lastExecution))
		} else {
			lastExecution = now
			func.apply(context, args)
		}
	}
}
